// extracted by mini-css-extract-plugin
export default {"scrollButton":"QY898YJWhzgAQl7IkEhE"};